import { CSSProperties, useEffect, useState } from 'react'
import { Gradient } from 'types'
import { gradientToCss } from 'utils'

export function useHighlightStyle(isOn: boolean, color: string, gradient?: Gradient) {
    const [value, setValue] = useState<CSSProperties>({})

    useEffect(() => {
        let background = color

        if (gradient) {
            background = gradientToCss(gradient)
        }

        setValue({
            background,
            transform: `translate3d(${isOn ? 100 : 0}%, 0, 0)`,
        })
    }, [color, gradient, isOn])

    return value
}
